export const EDITOR_CONTENT_CLASS = 'editor-styles-wrapper';
